module.exports = __webpack_public_path__ + "static/Dots-386abf574624e64e7d16eb7b5c013f94.png";